import { AddColorHeader } from "./TrayPlacementTools.js"
import { GameObjects } from "phaser";
import { SetUpOnClick } from "./TrayItemsClickedActions/OrnamentClickHandler.js"

export function OrnamentTab(Scene,Tray)
{
    AddColorHeader(Scene,Tray);
    const ColumnXPosistion = [];
    const TabAdjustment = 18;
    ColumnXPosistion[0] = Tray.x - (Tray.width/4) + TabAdjustment - 30;
    ColumnXPosistion[1] = Tray.x + TabAdjustment-15;
    ColumnXPosistion[2] = Tray.x + (Tray.width/4) + TabAdjustment;

    const AllOrnamentBodiesColumn1 = [
        [
            Scene.addImage(ColumnXPosistion[0],100,"Orn1"),
            Scene.addImage(ColumnXPosistion[0],100,"Orn_Hk2")
        ],
        [
            Scene.addImage(ColumnXPosistion[0],100,"Orn4"),
            Scene.addImage(ColumnXPosistion[0],100,"Orn_Hk2")
        ],
        [
            Scene.addImage(ColumnXPosistion[0],100,"Fzbg_Body"),
            Scene.addImage(ColumnXPosistion[0],100,"Orn_Hk1"),
            Scene.addImage(ColumnXPosistion[0],100,"Fzbg_Face"),
            Scene.addImage(ColumnXPosistion[0],100,"Fzbg_Limbs")
        ],
        [
            Scene.addImage(ColumnXPosistion[0],100,"Orn_Snwflk")
        ],
        [
            Scene.addImage(ColumnXPosistion[0],100,"Orn_StarGld")
        ],
        [
            Scene.addImage(ColumnXPosistion[0],100,"Orn_WrthLt")
        ],
        [
            Scene.addImage(ColumnXPosistion[0],100,"Orn_BellGld")
        ],
        [
            Scene.addImage(ColumnXPosistion[0],100,"Orn_Crdnl")
        ],
        [
            Scene.addImage(ColumnXPosistion[0],100,"Orn_Bsbl")
        ]
    ];

    const AllOrnamentBodiesColumn2 = [
        [
            Scene.addImage(ColumnXPosistion[1],100,"Orn2"),
            Scene.addImage(ColumnXPosistion[1],100,"Orn_Hk1")
        ],
        [
            Scene.addImage(ColumnXPosistion[1],100,"Orn5"),
            Scene.addImage(ColumnXPosistion[1],100,"Orn_Hk1")
        ],
        [
            Scene.addImage(ColumnXPosistion[1],100,"CndyCn_Strps"),
            Scene.addImage(ColumnXPosistion[1],100,"Orn_Hk1"),
            Scene.addImage(ColumnXPosistion[1],100,"CndyCn_BG")
        ],
        [
            Scene.addImage(ColumnXPosistion[1],100,"Orn_Tree")
        ],
        [
            Scene.addImage(ColumnXPosistion[1],100,"Orn_Slvr")
        ],
        [
            Scene.addImage(ColumnXPosistion[1],100,"Orn_WrthDk")
        ],
        [
            Scene.addImage(ColumnXPosistion[1],100,"Orn_Slvr_1")
        ],
        [
            Scene.addImage(ColumnXPosistion[1],100,"Orn_Music")
        ],
        [
            Scene.addImage(ColumnXPosistion[1],100,"Orn_Bsktbl")
        ]   
    ];

    const AllOrnamentBodiesColumn3 = [
        [
            Scene.addImage(ColumnXPosistion[2],100,"Orn3"),
            Scene.addImage(ColumnXPosistion[2],100,"Orn_Hk2")
        ],
        [
            Scene.addImage(ColumnXPosistion[2],100,"Orn6"),
            Scene.addImage(ColumnXPosistion[2],100,"Orn_Hk2")
        ],
        [
            Scene.addImage(ColumnXPosistion[2],100,"Stkng_BG"),
            Scene.addImage(ColumnXPosistion[2],100,"Orn_Hk1"),
            Scene.addImage(ColumnXPosistion[2],100,"Stkng_WhtTop")
        ],
        [
            Scene.addImage(ColumnXPosistion[2],100,"Orn_Gngr")
        ],
        [
            Scene.addImage(ColumnXPosistion[2],100,"Orn_Pngn")
        ],
        [
            Scene.addImage(ColumnXPosistion[2],100,"Orn_Bear")
        ],
        [
            Scene.addImage(ColumnXPosistion[2],100,"Orn_Snwmn")
        ],
        [
            Scene.addImage(ColumnXPosistion[2],100,"Orn_Ftbl")
        ],
        [
            Scene.addImage(ColumnXPosistion[2],100,"Orn_Scrbl")
        ],   
    ];

    for (let x = 0; x < AllOrnamentBodiesColumn1.length;x++)
    {
        ColumnPlacerSwitch(x,AllOrnamentBodiesColumn1);
        ColumnPlacerSwitch(x,AllOrnamentBodiesColumn2);
        ColumnPlacerSwitch(x,AllOrnamentBodiesColumn3);
    }

    //SetUpOnClick(AllOrnamentBodiesColumn1);

    Scene.ColorGroup.getChildren().forEach(element =>
        {
            element.setTint(0xF70D0D);
        });

    Scene.TrayGroup.getChildren().forEach(element =>
        {
            let TestArray = [1,2,3];
            //console.log(typeof TestArray);
            element.setInteractive();
        });

    SetUpOnClick(AllOrnamentBodiesColumn1);
    SetUpOnClick(AllOrnamentBodiesColumn2);
    SetUpOnClick(AllOrnamentBodiesColumn3);
    //Scene.TrayGroup.clear(true,true);
}

function ColumnPlacerSwitch(x,AllOrnamentBodiesColumn)
{
    //const InitialHeight = 120;
    const DeterminedHeight = [168,239,315,385,458,531,604,670,731];
    const GapBetween = 11;
    const Scene = AllOrnamentBodiesColumn[x][0].scene;
    const DepthList = Scene.DepthList;
    switch(x)
        {
            case 0:
            {
                //AllOrnamentBodiesColumn[x][0].y = InitialHeight + (AllOrnamentBodiesColumn[x][0].height*.5) + GapBetween + (AllOrnamentBodiesColumn[x][1].height*.75);
                AllOrnamentBodiesColumn[x][0].y = DeterminedHeight[x];
                AllOrnamentBodiesColumn[x][1].y = AllOrnamentBodiesColumn[x][0].getTopCenter().y - (AllOrnamentBodiesColumn[x][1].height*.25);

                let HangerDist = AllOrnamentBodiesColumn[x][0].y - AllOrnamentBodiesColumn[x][1].y;

                AllOrnamentBodiesColumn[x][0].setDepth(DepthList.OrnBack);
                AllOrnamentBodiesColumn[x][1].setDepth(DepthList.OrnFront);

                Scene.TrayGroup.add(AllOrnamentBodiesColumn[x][0]);
                Scene.TrayGroup.add(AllOrnamentBodiesColumn[x][1]);

                Scene.ColorGroup.add(AllOrnamentBodiesColumn[x][0]);

                AllOrnamentBodiesColumn[x][0].setData('Attachment',[[0,HangerDist,AllOrnamentBodiesColumn[x][1].frame.name]]);

                // AllOrnamentBodiesColumn[x][0].on('pointerdown',function(Pointer){
                //     //console.log(element.length);
                //     var CopyOf = this.scene.addImage(0,0,this.frame.name);
                //     var Attachment = this.scene.addImage(CopyOf.x,0,"Orn_Hk2");
    
                //     let Cont = this.scene.add.container(Pointer.x,Pointer.y,[CopyOf,Attachment]);
    
                //     Cont.setSize(CopyOf.width, CopyOf.height);
                    
                //     Attachment.y = CopyOf.getTopCenter().y - (Attachment.height*.25);
                    
                //     Cont.setInteractive();
                //     this.scene.input._drag[0][0] = CopyOf;
                //     this.scene.input.setDraggable(Cont);
    
                //     this.scene.input._drag[0][0] = CopyOf;
                //     this.scene.input.setDragState(this.scene.input.activePointer,4);
                // });
            }
            break;

            case 1:
            //case 2:

            {
                //AllOrnamentBodiesColumn[x][0].y = AllOrnamentBodiesColumn[x-1][0].y + (AllOrnamentBodiesColumn[x-1][0].height*.5) + GapBetween + (AllOrnamentBodiesColumn[x][0].height*.5) + (AllOrnamentBodiesColumn[x][1].height*.75);
                AllOrnamentBodiesColumn[x][0].y = DeterminedHeight[x];
                AllOrnamentBodiesColumn[x][1].y = AllOrnamentBodiesColumn[x][0].getTopCenter().y - (AllOrnamentBodiesColumn[x][1].height*.25);
            
                AllOrnamentBodiesColumn[x][0].setDepth(DepthList.OrnBack);
                AllOrnamentBodiesColumn[x][1].setDepth(DepthList.OrnFront);

                Scene.TrayGroup.add(AllOrnamentBodiesColumn[x][0]);
                Scene.TrayGroup.add(AllOrnamentBodiesColumn[x][1]);

                Scene.ColorGroup.add(AllOrnamentBodiesColumn[x][0]);

                let HangerDist = AllOrnamentBodiesColumn[x][0].y - AllOrnamentBodiesColumn[x][1].y;

                AllOrnamentBodiesColumn[x][0].setData('Attachment',[[0,HangerDist,AllOrnamentBodiesColumn[x][1].frame.name]]);
            }
            break;

            case 2:
            {
               SpecialCaseSwitch(AllOrnamentBodiesColumn[x],AllOrnamentBodiesColumn[x-1],AllOrnamentBodiesColumn[x+1],GapBetween,DeterminedHeight);
            }
            break;

            case 3:
                AllOrnamentBodiesColumn[x][0].setDepth(DepthList.OrnFront);

                Scene.TrayGroup.add(AllOrnamentBodiesColumn[x][0]);
                
                //skips 3 placement as it is handled in special
            break;

            default:
            {
                //AllOrnamentBodiesColumn[x][0].y = AllOrnamentBodiesColumn[x-1][0].y + (AllOrnamentBodiesColumn[x-1][0].height*.5) + (AllOrnamentBodiesColumn[x][0].height*.5) + GapBetween;
                AllOrnamentBodiesColumn[x][0].y = DeterminedHeight[x];

                Scene.TrayGroup.add(AllOrnamentBodiesColumn[x][0]);

                AllOrnamentBodiesColumn[x][0].setDepth(DepthList.OrnFront);
            }
            break;
        }
}

function SpecialCaseSwitch(Special,Previous, Next, GapBetween,DeterminedHeight)
{
    const FirstLetter = Special[0].frame.name[0];
    const Scene = Special[0].scene;
    const DepthList = Scene.DepthList;
    var HangerDist = []
    //console.log(FirstLetter);

    switch(FirstLetter)
    {
        //Case fuzzbug
        case "F":
            Special[0].y = DeterminedHeight[2] - 5;//will always be 2
            //Special[0].y = Previous[0].y + (Previous[0].height*.5) + ((Special[0].height*.5) + (Special[1].height*.4)) + GapBetween;
            //console.log(Previous[1].height*.5);
            Special[1].y = Special[0].getTopCenter().y - (Special[1].height * .2);
            Special[2].y = Special[0].y - (Special[2].height*.25);//Face
            Special[3].y = Special[0].y + (Special[3].height*.5);//Limbs

            HangerDist[0] = Special[0].y - Special[1].y;
            HangerDist[1] = Special[0].y - Special[2].y;
            HangerDist[2] = Special[0].y - Special[3].y;

            Scene.ColorGroup.add(Special[0]);

            Special[0].setDepth(DepthList.OrnMiddle);
            Special[1].setDepth(DepthList.OrnFront);
            Special[2].setDepth(DepthList.OrnFront);
            Special[3].setDepth(DepthList.OrnBack);

            Scene.TrayGroup.addMultiple(Special);
            
            let HeightWithLegs = ((Special[3].getBottomCenter().y - Special[1].getTopCenter().y)*.5);

            Special[0].setData('Attachment',[
                [0,HangerDist[0],Special[1].frame.name],
                [0,HangerDist[1],Special[2].frame.name],
                [0,HangerDist[2],Special[3].frame.name]
            ]);

            Special[2].setData('Body',Special[0]);

            Next[0].y = DeterminedHeight[3];
            //Next[0].y = Special[0].y + HeightWithLegs + (Next[0].height*.5) + GapBetween;
            break;
        //Case Candy Cane
        case "C":
            Special[0].y = DeterminedHeight[2];
            //Special[0].y = Previous[0].y + (Previous[0].height*.5)+((Special[0].height*.5) + (Special[1].height - (Special[1].height * .3)) + GapBetween);
            Special[1].y = Special[0].getTopCenter().y - (Special[1].height * .2);
            Special[2].y = Special[0].y;

            HangerDist[0] = Special[0].y - Special[1].y;
            HangerDist[1] = Special[0].y - Special[2].y;

            Special[0].setData('Attachment',[
                [0,HangerDist[0],Special[1].frame.name],
                [0,HangerDist[1],Special[2].frame.name]
            ]);

            Special[0].setDepth(DepthList.OrnFront);
            Special[1].setDepth(DepthList.OrnFront);
            Special[2].setDepth(DepthList.OrnBack);

            Scene.TrayGroup.addMultiple(Special);

            Scene.ColorGroup.add(Special[0]);

            Special[0].setTint(0xFC3232);

            Next[0].y = DeterminedHeight[3];
            //Next[0].y = Special[0].y + (Special[0].height*.5)+(Next[0].height*.5) + GapBetween;
            break;
        //Case Stocking
        case "S":
            Special[0].y = DeterminedHeight[2];
            //Special[0].y = Previous[0].y + (Previous[0].height*.5)+(33) + GapBetween;
            Special[1].y = Special[0].y - 33;
            Special[1].x = Special[0].x + 14;
            Special[2].y = Special[0].y - 19;
            Special[2].x = Special[0].x + 5;

            Special[0].setDepth(DepthList.OrnBack);
            Special[1].setDepth(DepthList.OrnFront);
            Special[2].setDepth(DepthList.OrnMiddle);

            HangerDist[0] = Special[0].y - Special[1].y;
            HangerDist[1] = Special[0].y - Special[2].y;

            Special[0].setData('Attachment',[
                [14,HangerDist[0],Special[1].frame.name],
                [5,HangerDist[1],Special[2].frame.name]
            ]);

            Scene.TrayGroup.addMultiple(Special);

            Scene.ColorGroup.add(Special[0]);

            Next[0].y = DeterminedHeight[3];
            //Next[0].y = Special[0].y + (Special[0].height*.5)+(Next[0].height*.5) + GapBetween;
            break;
    }
}